import { render, staticRenderFns } from "./Group3Subsection.vue?vue&type=template&id=4859673c&scoped=true"
import script from "./Group3Subsection.vue?vue&type=script&lang=js"
export * from "./Group3Subsection.vue?vue&type=script&lang=js"
import style0 from "./Group3Subsection.vue?vue&type=style&index=0&id=4859673c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../imported/work/site/src/project/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4859673c",
  null
  
)

export default component.exports